import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';

import { AddNewPartnerComponent } from '../components/add-new-partner/add-new-partner.component';
import { ListPartnersComponent } from '../components/list-partners/list-partners.component';
import { PartnersRoutingModule } from './partners-routing.module';
import { PartnersComponent } from './partners.component';
import { EditPartnerComponent } from '../edit-partner/edit-partner.component';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { EditPartnerModule } from '../edit-partner/edit-partner.module';

const components = [PartnersComponent, ListPartnersComponent, AddNewPartnerComponent];

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    PartnersRoutingModule,
    SharedModule,
    MatIconModule,
    EditPartnerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    MatMenuModule
  ],
  declarations: [...components]
})
export class PartnersModule { }
